import Swal from "sweetalert2";
import api from "../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export const getPreciosByIdRuta = (id_ruta,setPrecios)=>
    {
        api.get(`${apiUrl}/monitor/precios/getPrecios?id_ruta=${id_ruta}`).then((res)=>{
            setPrecios(res.data)
            
        })
        .catch((error)=>{
            console.log("error",error);
        })
    }